import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Reveal, SectionHeading } from "./Reveal";

export default function Services({ services, settings }) {
  return (
    <section id="services" data-testid="services-section" className="bg-lavender-50 py-20 lg:py-24">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 sm:px-8 lg:grid-cols-[0.8fr_1.4fr] lg:gap-20">
        <div>
          <SectionHeading kicker="Services & pricing" title="Find the right groom." description="Select a service to see what's included. Final pricing depends on your dog's size, coat condition and temperament." />
          <p data-testid="policy-note" className="mt-8 border-l-2 border-lavender-300 pl-5 text-sm leading-relaxed text-stone-600">
            {settings.policy}
          </p>
        </div>
        <Reveal>
          <Accordion type="single" collapsible data-testid="services-accordion" className="border-t border-lavender-700/20">
            {services.map((s, i) => (
              <AccordionItem key={s.id || s.name} value={s.id || String(i)} data-testid={`service-row-${s.id || i}`} className="border-lavender-700/20">
                <AccordionTrigger showChevron={false} data-testid={`service-toggle-${s.id || i}`} className="group gap-4 px-1 py-6 font-semibold transition-colors hover:bg-lavender-100/60 hover:no-underline [&[data-state=open]_.service-indicator]:rotate-45">
                  <span className="grid min-w-0 flex-1 gap-1 text-left sm:grid-cols-[1fr_auto] sm:items-center sm:gap-4">
                    <span data-testid={`service-name-${s.id || i}`} className="text-base text-stone-900 md:text-lg">{s.name}</span>
                    <span data-testid={`service-price-${s.id || i}`} className="whitespace-nowrap text-sm font-medium tabular-nums text-lavender-800">
                      {settings.showPrices ? s.price : "Call for pricing"}
                    </span>
                  </span>
                  <span aria-hidden="true" className="service-indicator relative h-5 w-5 shrink-0 transition-transform duration-200 before:absolute before:left-0 before:top-1/2 before:h-px before:w-5 before:bg-lavender-700 after:absolute after:left-1/2 after:top-0 after:h-5 after:w-px after:bg-lavender-700" />
                </AccordionTrigger>
                <AccordionContent data-testid={`service-description-${s.id || i}`} className="max-w-xl px-1 pb-6 text-sm leading-relaxed text-stone-600 sm:text-base">
                  {s.description}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
